import {formatDate} from "./format"

export const NO_SKIP = ["NO_SKIP"]

export const buildData = (data, skipKeys = NO_SKIP) => {
  if (data == null) return {}

  if (skipKeys === NO_SKIP || skipKeys == null) {
    skipKeys = new Set()
  } else {
    skipKeys = new Set(skipKeys)
  }

  const newData = {}

  for (const [key, value] of Object.entries(data)) {
    if (skipKeys.has(key)) {
      continue
    }

    newData[key] = value
  }

  return newData
}

/**
 * Normalizes a value for comparison: coerces null/undefined to null,
 * and formats date-related keys for consistent comparison.
 * @param {string} key - The property key
 * @param {*} value - The value to normalize
 * @returns {*} Normalized value
 */
const normalizeForComparison = (key, value) => {
  const normalized = value ?? null

  if (!key.toLowerCase().includes("date")) return normalized

  const formatted = formatDate(normalized)
  return formatted !== "Invalid Date" ? formatted : normalized
}

export const getChanges = (base, current) => {
  if (!base) {
    return !!current && Object.keys(current).length ? current : null
  }

  if (!current || !Object.keys(current).length) {
    return null
  }

  const allKeys = new Set(Object.keys(base).concat(Object.keys(current)))
  const changes = {}
  let hasChanges = false

  for (const key of allKeys) {
    const s = normalizeForComparison(key, base[key])
    const c = normalizeForComparison(key, current[key])

    if (s !== c) {
      hasChanges = true
      // Store original current value, not the display-formatted one.
      // Date fields are normalized above for comparison only.
      changes[key] = current[key] ?? null
    }
  }

  return hasChanges ? changes : null
}
